import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=0fd3a3a4&"
import script from "./Admin.vue?vue&type=script&lang=ts&"
export * from "./Admin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports